import { fetchAuthSession } from 'aws-amplify/auth';

/**
 * Get Cognito groups from the current user's ID token.
 */
export const getUserGroups = async (): Promise<string[]> => {
  try {
    const session = await fetchAuthSession();
    const idToken = session.tokens?.idToken;
    const groups: string[] = Array.isArray(idToken?.payload['cognito:groups'])
      ? idToken.payload['cognito:groups'] as string[]
      : [];
    return groups;
  } catch (error) {
    console.error('Error getting Cognito groups:', error);
    return [];
  }
};